import React from "react";
import { FiMail, FiPhone, FiCalendar, FiEye, FiEdit } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

function getStatusClass(status) {
  if (status === "Active") return "status-active";
  if (status === "Inactive") return "status-inactive";
  if (status === "On Leave") return "status-onleave";
  return "status-other";
}

function formatJoinDate(dateStr) {
  // Handles both "2012-05-15" and "May 15, 2012"
  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr;

  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-GB", { month: "short" }); // Sep
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}


function StaffListGrid({ data = [] }) {
  const navigate=useNavigate();
  return (
    <div className="staff-grid-root">
      <div className="staff-grid-cards">
        {data.map((person) => (
          <div className="staff-grid-card" key={person.id}>
            <div className="staff-grid-header">
              <div className="staff-grid-header-info">
                <img
                  src={person.avatar || "https://cdn3d.iconscout.com/3d/premium/thumb/medical-patient-profile-3d-icon-png-download-11172608.png"}
                  alt={person.name}
                  className="staff-grid-avatar"
                />
                <div>
                  <div className="staff-grid-name">{person.name}</div>
                  <div className="staff-grid-role">{person.role}</div>
                </div>
              </div>
              <span className={`staff-grid-status ${getStatusClass(person.status)}`}>
                {person.status}
              </span>
            </div>
            <div className="staff-grid-body">
              <div className="staff-grid-detail">
                <FiCalendar className="icon" /> {person.department}
              </div>
              <div className="staff-grid-detail">
                <FiMail className="icon" /> {person.contact}
              </div>
              <div className="staff-grid-detail">
                <FiPhone className="icon" /> {person.phone}
              </div>
              <div className="staff-grid-detail">
                <FiCalendar className="icon" /> Joined {formatJoinDate(person.joined)}
              </div>
            </div>
            <div className="staff-grid-actions">
              <button className="action-btn" onClick={()=>navigate("/StaffView")}><FiEye /> View</button>
              <button className="action-btn"><FiEdit /> Edit</button>
            </div>
          </div>
        ))}
      </div>
      <style>{`
        .staff-grid-root {
          width: 100%;
        }
        .staff-grid-cards {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          gap: 1.2rem;
        }
        .staff-grid-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.09);
  padding: 1.1rem 1.2rem 1rem 1.2rem;
  display: flex;
  flex-direction: column;
  min-width: 0;
  transition: box-shadow 0.18s cubic-bezier(.4,0,.2,1), transform 0.18s cubic-bezier(.4,0,.2,1);
}
.staff-grid-card:hover {
  box-shadow: 0 4px 24px rgba(21, 52, 84, 0.14), 0 1.5px 7px rgba(60, 90, 130, 0.08);
  transform: translateY(-3px) scale(1.02);
  cursor: pointer;
}

        .staff-grid-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: .6rem;
        }
        .staff-grid-header-info {
          display: flex;
          align-items: center;
          gap: .8rem;
        }
        .staff-grid-avatar {
          width: 45px;
          height: 45px;
          object-fit: cover;
          border-radius: 50%;
          background: #eee;
          margin-right: .7rem;
        }
        .staff-grid-name {
          font-size: 1.08rem;
          font-weight: 800;
          color: #213343;
        }
        .staff-grid-role {
          font-size: .93rem;
          color: #4a5758;
          margin-top: .08rem;
        }
        .staff-grid-status {
          font-size: .93rem;
          font-weight: 700;
          border-radius: 13px;
          padding: .25rem 1.07rem;
          min-width: 78px;
          text-align: center;
        }
        .status-active {
          background: #34d399;
          color: #fff;
          font-size:10px;
        }
        .status-inactive {
          background: #e5e7eb;
          color: #4b5563;
          font-size:10px;
        }
        .status-onleave {
          background: #f54242ff;
          color: #fff;
          font-size:10px;
        }
        .status-other {
          background: #d1d5db;
          color: #2d3748;
        }
        .staff-grid-body {
          margin-bottom: .6rem;
        }
        .staff-grid-detail {
          display: flex;
          align-items: center;
          color: #3C495B;
          font-size: .98rem;
          margin-bottom: .16rem;
          gap: .37rem;
        }
        .icon {
          display: inline-flex;
          vertical-align: middle;
          margin-right: .17rem;
        }
        .staff-grid-actions {
          margin-top: .7rem;
          border-top: 1.2px solid #eee;
          padding-top: .7rem;
          display: flex;
          gap: 1.1rem;
          justify-content: flex-start;
        }
        .action-btn {
          background: none;
          border: none;
          color: #175CD3;
          font-weight: 600;
          font-size: .98rem;
          display: inline-flex;
          align-items: center;
          gap: .36rem;
          cursor: pointer;
          transition: color .14s;
          padding: 0 .15rem;
        }
        .action-btn:hover {
          color: #0e314f;
        }
      `}</style>
    </div>
  );
}

export default StaffListGrid;
